import { Notification } from "@drone-js/core";
import type { FunctionComponent } from "react";

interface Props {
    message: string;
}

export const ErrorNotification: FunctionComponent<Props> = ({ message }) => {
    return (
        <Notification
            intent="error"
            asset={{
                id: "fill.symbol.triangle-exclamation",
            }}
            title={message}
            data-element-name="please-add-location"
        />
    );
};
